import React from 'react'

export function Forbidden() {
  return <p className='p-5'>We’re sorry, your account does not currently have permission to perform this action.</p>
}
